module.exports = __webpack_public_path__ + "static/media/Roman Emperor.f17ba7b0.jpg";